import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import BeneficiarySyncActionCreator from '../actions/BeneficiarySyncActionCreator';
const _getBenList =
  '/ibapi/v2/banks/{bank-id}/accounts/default/import/beneficiaries';
const _addPayeeUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/account';

class BeneficiarySyncApiUtils {
  static fetchBeneficiaryToSync() {
    const url = `${envConfig.apiBaseUrlPAAS}${_getBenList}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        BeneficiarySyncActionCreator.handleFetchSuccess(body);
      },
      (error) => {
        BeneficiarySyncActionCreator.handleFetchFail(error);
      }
    );
  }

  static addBeneficiary(payload, associatedAccountID) {
    const requestData = JSON.stringify(payload);
    const url = `${envConfig.apiBaseUrlPAAS}${_addPayeeUrl.replace(
      '{accountId}',
      associatedAccountID
    )}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        BeneficiarySyncActionCreator.handleSyncSuccess(
          body,
          associatedAccountID
        );
      },
      () => {
        BeneficiarySyncActionCreator.handleSyncFail();
      }
    );
  }
}
export default BeneficiarySyncApiUtils;
